import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { webhookSubscriptionsQueryKeys } from "../key-factory/factory";

export const useRemoveWebhookSubscriptionMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: webhookSubscriptionsQueryKeys.remove(),
        retry: 2,
        retryDelay: 200,
        mutationFn(subscriptionId: string) {
            return salesApiService.management.removeWebhookSubscription(subscriptionId);
        },
        onSuccess() {
            queryClient.invalidateQueries({
                queryKey: webhookSubscriptionsQueryKeys.list(),
                refetchType: "inactive",
            });
        },
    });
};
